import { createApi } from '@reduxjs/toolkit/query/react';
import { Response } from '../../models/shared';
import { AvanttiReport, PaymentDTO } from '../../models/payment';
import baseQueryWithReauth from './base';

const paymentsApi = createApi({
  reducerPath: 'paymentsApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['payments'],
  endpoints: (build) => ({
    getPaymentById: build.query<PaymentDTO | null, { paymentId: string }>({
      query: ({ paymentId }) => ({
        url: `/payments/${paymentId}`,
        method: 'GET',
      }),
      transformResponse: (response: Response<PaymentDTO>): (PaymentDTO | null) => response.data || null,
    }),
    getPaymentByOrderId: build.query<PaymentDTO[] | null, { orderId: string, eventId: string, businessId: string }>({
      query: ({ orderId, eventId, businessId }) => ({
        url: `/businesses/${businessId}/events/${eventId}/payments/order/${orderId}`,
        method: 'GET',
      }),
      transformResponse: (response: Response<PaymentDTO[]>): (PaymentDTO[] | null) => response.data || null,
    }),
    getAvanttiPaymentReport: build.query<AvanttiReport | null, { startDate: string, endDate: string }>({
      query: ({ startDate, endDate }) => ({
        url: '/payments/all/report',
        method: 'GET',
        params: {
          start: startDate,
          end: endDate,
        },
      }),
      transformResponse: (response: Response<AvanttiReport>): (AvanttiReport | null) => response.data || null,
      providesTags: ['payments'],
    }),
    getEventPaymentReport: build.query<PaymentDTO[] | null, { eventId: string, businessId: string }>({
      query: ({ eventId, businessId }) => ({
        url: `/businesses/${businessId}/events/${eventId}/payments`,
        method: 'GET',
      }),
      transformResponse: (response: Response<PaymentDTO[]>): (PaymentDTO[] | null) => response.data || null,
      providesTags: ['payments'],
    }),
    getEventPaymentReportXlsx: build.mutation<Blob | null, { eventId: string, businessId: string }>({
      query: ({ eventId, businessId }) => ({
        url: `/businesses/${businessId}/events/${eventId}/payments?xlsx=true`,
        method: 'GET',
        responseHandler: async (response) => {
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `lista-socios-${new Date().toLocaleDateString('es-AR', { year: 'numeric', month: '2-digit', day: '2-digit' })}-${businessId}.xlsx`;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        },
      }),
    }),
  }),
});

export const {
  useGetPaymentByIdQuery,
  useGetAvanttiPaymentReportQuery,
  useGetEventPaymentReportQuery,
  useGetPaymentByOrderIdQuery,
  useGetEventPaymentReportXlsxMutation,
} = paymentsApi;
export { paymentsApi };
